import { CLOSE_MODAL, SHOW_MODAL } from './types';
const initialState = {
    isOpen: false,
    modalProps: {},
};
export const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                ...state,
                isOpen: true,
                modalProps: action.modalProps,
            };
        case CLOSE_MODAL:
            return {
                ...state,
                isOpen: false,
            };
        default:
            return state;
    }
};
